import { render } from "./homeEvaStat.vue?vue&type=template&id=089f5560&scoped=true"
import script from "./homeEvaStat.vue?vue&type=script&lang=js"
export * from "./homeEvaStat.vue?vue&type=script&lang=js"

import "./homeEvaStat.vue?vue&type=style&index=0&id=089f5560&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089f5560"]])

export default __exports__